/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Password reset request
 */
export interface PasswordResetRequest {
  email: string;
}
